import React from 'react';

import style from './styles.module.scss';

export default function Logo({ dark }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="92"
            height="30"
            viewBox="0 0 92 30"
            className={`${style['svg-base']} ${style.svg} ${
                dark ? style['svg--dark'] : ''
            }`}>
            <path
                fillRule="evenodd"
                d={`M63.4,16.9L60,19.5l2.9,3.9c-1.2,1.5-3,2.8-5.1,4.4l1.5,2.2c4-2.7,6.5-5.4,6.5-8C65.8,20,65.2,18.8,63.4,16.9z
     M46.2,3.8c1.3-0.4,2.7-0.6,4.3-0.6c3.9,0,5,1.6,5.1,6c-3.8,0.1-7.3,0.6-10.5,1.3C45.1,8.5,45.3,6,46.2,3.8z M59.1,15.8h-3.5
    c0,0.7,0,1.7-0.1,2.7c-1,0.4-2.3,0.6-3.6,0.6c-5.2,0-6.5-3-6.7-7h13.9c0.1-1.1,0.2-2.2,0.2-3.2c0-5.6-2.6-8.8-8-8.8
    c-6.7,0-9.8,4.2-9.8,11.4c0,8.1,3.4,10.9,9.7,10.9c5.4,0,7.9-1.9,7.9-6.1V15.8z M34.7,12.2c0,1.8-0.1,3.3-0.6,4.8
    c-1.9,1.1-4.1,1.8-5.9,1.8c-2.6,0-3.2-0.9-3.2-3.2c0-0.6,0-1.3,0.2-2c2.6-0.8,7.1-0.4,9.5-1.6L34.7,12.2L34.7,12.2z M38.4,16.5V6.7
    C38.4,1.9,35.8,0,31,0c-5.1,0-8.6,2.3-8.6,6.2v0.6h3.8V6c0-0.9,0-1.7,0.2-2.5c1.4-0.2,2.8-0.4,4.2-0.4c3,0,4,1.5,4,4.3v3.1h-5.8
    c-5.9,0-7.5,2.6-7.5,6c0,4.3,2.4,5.7,5.6,5.7c3.2,0,5.5-1.7,7.9-3.9c0.5,3,2.3,3.9,4.9,3.9c0.9,0,1.4,0,1.8-0.1v-3.5
    c-0.5,0.1-0.9,0.1-1.4,0.1C38.6,18.8,38.4,17.9,38.4,16.5L38.4,16.5z M13.4,0c-3.6,0-6.2,2-9,4.9V0.5H0.7v21.3h3.7V11.5
    c0-1.8,0.1-3.4,0.6-4.9c2.4-1.9,4.7-3,6.5-3c2.4,0,3.5,1.2,3.5,3.7v14.6h3.7V5.9C18.7,1.7,15.9,0,13.4,0z`}
            />
        </svg>
    );
}
